import axios from 'axios';
import { MainBanner, RegularBanner, TextAd } from '../types/banner';

// 환경 변수로 API URL 설정
// 로컬 개발: REACT_APP_API_URL=http://localhost:8000 또는 자동으로 localhost:8000 사용
// 배포 환경: REACT_APP_API_URL을 설정하지 않으면 빈 문자열 (같은 도메인)
const getApiBaseUrl = () => {
	// 환경 변수가 명시적으로 설정되어 있으면 사용 (최우선)
	if (process.env.REACT_APP_API_URL !== undefined && process.env.REACT_APP_API_URL !== '') {
		return process.env.REACT_APP_API_URL;
	}
	// 개발 모드이고 환경 변수가 없으면 localhost:8000 사용
	if (process.env.NODE_ENV === 'development') {
		return 'http://localhost:8000';
	}
	// 프로덕션 모드면 빈 문자열 (같은 도메인에서 서빙)
	return '';
};
const API_BASE_URL = getApiBaseUrl();
const api = axios.create({ 
  baseURL: API_BASE_URL, 
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true // 쿠키 기반 세션 지원
});

export const bannerAPI = {
  getMainBanners: async (): Promise<any> => {
    const response = await api.get('/banners/api/main-banners');
    return response;
  },
  createMainBanner: async (data: FormData): Promise<any> => {
    const response = await api.post('/banners/api/main-banners', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
  updateMainBanner: async (id: number, data: FormData): Promise<any> => {
    const response = await api.put(`/banners/api/main-banners/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
  deleteMainBanner: async (id: number): Promise<any> => {
    const response = await api.delete(`/banners/api/main/${id}`);
    return response;
  },
  getRegularBanners: async (): Promise<any> => {
    const response = await api.get('/banners/api/regular-banners');
    return response;
  },
  createRegularBanner: async (data: FormData): Promise<any> => {
    const response = await api.post('/banners/api/regular-banners', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
  updateRegularBanner: async (id: number, data: FormData): Promise<any> => {
    const response = await api.put(`/banners/api/regular-banners/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
  deleteRegularBanner: async (id: number): Promise<any> => {
    const response = await api.delete(`/banners/api/regular/${id}`);
    return response;
  },
  getTextAds: async (): Promise<any> => {
    const response = await api.get('/banners/api/text-ads');
    return response;
  },
  createTextAd: async (data: FormData): Promise<any> => {
    const response = await api.post('/banners/api/text-ads', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
  updateTextAd: async (id: number, data: FormData): Promise<any> => {
    const response = await api.put(`/banners/api/text-ads/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
  deleteTextAd: async (id: number): Promise<any> => {
    const response = await api.delete(`/banners/api/text-ads/${id}`);
    return response;
  },
};

export const adminAPI = {
  getAdmins: async (): Promise<any> => {
    const response = await api.get('/admin/api/admins');
    return response;
  },
  createAdmin: async (data: { name: string; password: string }): Promise<any> => {
    const response = await api.post('/admin/api/admins', data);
    return response;
  },
  login: async (data: { name: string; password: string }): Promise<any> => {
    const response = await api.post('/admin/api/login', data);
    return response;
  },
  logout: async (): Promise<any> => {
    const response = await api.post('/admin/api/logout');
    return response;
  },
  changePassword: async (data: { currentPassword: string; newPassword: string; confirmPassword: string }): Promise<any> => {
    const response = await api.post('/admin/api/change-password', {
      current_password: data.currentPassword,
      new_password: data.newPassword,
      confirm_password: data.confirmPassword,
    });
    return response;
  },
  getCurrentAdmin: async (): Promise<any> => {
    const response = await api.get('/admin/api/me');
    return response;
  },
};

export default api;
